import React, { useEffect, useState } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button, Nav, Navbar, Card, Image, Tab, Tabs, Form, Modal } from 'react-bootstrap';
import '../App.css';
import '../css/landingPage.css';
import pencilIcon from '../assets/images/icons/pencil.png';
import manImage from '../assets/images/man-image.png';
import CustomShortenedURLSIcon from '../assets/images/icons/custom-short-url.png';
import BulkIcon from '../assets/images/icons/bulk.png';
import AdvancedAnalyticsIcon from '../assets/images/icons/Advanced-Analytics.png';
import UserManagementIcon from '../assets/images/icons/UserManagement.png';
import CreditManagementIcon from '../assets/images/icons/creditManagement.png';
import APIIntegrationIcon from '../assets/images/icons/APIIntegration.png';
import stepOne from '../assets/images/icons/Group 1171275978.png';
import stepTwo from '../assets/images/icons/Group 1171275984.png';
import stepThree from '../assets/images/icons/Group 1171275974.png';
import waveLine from '../assets/images/wave-line.png';
import { Colors } from 'chart.js';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import zigzagIcon from '../assets/images/icons/user-manual.png';
import contactIocn from '../assets/images/icons/contactIocn.png';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import apiDocIcon from '../assets/images/icons/apiDocIcon.png';
import supportIcon from '../assets/images/icons/supportIcon.png';
import LogoDark from '../assets/images/logo-black.png'; 
import Logo from '../assets/images/Logo.png'; 

const LandingPage = () => {
  const [showGuideModal, setShowGuideModal] = useState(false);
  const [showApiModal, setShowApiModal] = useState(false);

   useEffect(() => {
    // Add the 'bodyMain' class to the body tag
    document.body.classList.add('landingPageBody');

    // Cleanup: Remove the 'bodyMain' class when the component unmounts
    return () => {
      document.body.classList.remove('landingPageBody');
    };
  }, []);

  return (
    <>
     <div className='landing-page'>
      <Navbar bg="white" expand="lg" className="cus-navbar" sticky="top">
        <Container>
          <Navbar.Brand href="#home" className="fw-800 fs-24 text-101828"><Image src={LogoDark} width="130"/></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav>
            {/* <Nav.Link href="#" className="fs-14">About</Nav.Link> */}
              <Nav.Link href="#features" className="fs-14">Features</Nav.Link>
              <Nav.Link href="#documentation" className="fs-14">Documentation</Nav.Link>
              {/* <Nav.Link href="#pricing" className="fs-14">Pricing</Nav.Link> */}
              <Nav.Link href="#support" className="fs-14">Support</Nav.Link>
              <Button variant="" className="ms-4 br-radius-32 fs-12 btn-dark-outline" href="/auth/signup">Sign Up</Button>
           
              <Button variant="" className="ms-3 br-radius-32 fs-12 btn-dark" href="/auth/login">Login</Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="text-white py-5 bg-F5F5F5" style={{backgroundColor: '#F5F5F5'}}>
        <Container className="py-5">
          <Row className="align-items-center text-center justify-content-center">
            <Col lg={12} className="mb-4 mb-lg-0">
              <h1 className="display-4 fw-800 mb-2">Shorten, Share, Track</h1>
              <p className="fs-14 text-101828 fw-400 mb-3">
              Convert long links into short, trackable URLs – with full control over accounts, users,<br /> credits, and campaign performance.
              </p>
            </Col>
            <Col lg={8}>
              <div className="single-url-shortening-area position-relative">
              <Image src={manImage}  className="manImage"/>
                <div className='search-url position-relative z-0 overflow-hidden'>
                <Image src={pencilIcon} height="15" className="z-2 editIcon position-absolute"/>
                <div className="input-group mb-0 z-1 bg-white">
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Paste your long URL here" 
                  />
                  <Button variant="success" className="br-radius-32 fw-semibold fs-12 ps-4 pe-4">Shorten</Button>
                </div>
                </div>
                <p className="text-muted small GeneralSansLight fs-10 mt-3">Try our URL shortener now - no account required for basic features</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <section id="features" className="page-section">
        <Container>
          <Row className='justify-content-center'>
            <Col lg={10}>
          <div className="text-center mb-5">
            <h2 className="fw-700 ls-0 fs-34 mb-3">Powerful URL Management</h2>
            <p className="lead sub-heading">This powerful web application helps organizations generate short URLs for communication and campaign management. Whether you're working with single or bulk links, managing sender IDs, or tracking credit usage — this platform keeps you in control.”</p>
          </div>
          </Col>
          </Row>
          
          <Row className="g-4 mt-0">
            <Col md={4} className='position-relative'>
            <div className="borderThick"></div>
              <div className="h-100 border-0 pb-4 card-one border-thick position-relative bg-white">
                
                <div className="p-4">
                  <div className="feature-icon mb-4" style={{height: '30px'}}>
                    <Image src={CustomShortenedURLSIcon} width={30}/>
                  </div>

                  <h4 className="fw-700 fs-18">Custom Shortened URLs</h4>
                  <p className="fw-400 fs-12 mb-0">
                    Create branded links with your domain and sender ID that build trust with your audience.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={4} className='position-relative'>
            <div className="borderThick"></div>
              <div className="h-100 border-0 pb-4 card-one border-thick position-relative bg-white">
                
                <div className="p-4">
                  <div className="feature-icon mb-4"  style={{height: '30px'}}>
                    <Image src={BulkIcon} width={30}/>
                  </div>

                  <h4 className="fw-700 fs-18">Bulk URL Generation</h4>
                  <p className="fw-400 fs-12 mb-0">
                  Convert thousands of URLs at once with our easy-to-use bulk upload feature.
                  </p>
                </div>
              </div>
            </Col>

            <Col md={4} className='position-relative'>
            <div className="borderThick"></div>
              <div className="h-100 border-0 pb-4 card-one border-thick position-relative bg-white">
                
                <div className="p-4">
                  <div className="feature-icon mb-4"  style={{height: '30px'}}>
                    <Image src={AdvancedAnalyticsIcon} width={30}/>
                  </div>

                  <h4 className="fw-700 fs-18">Advanced Analytics</h4>
                  <p className="fw-400 fs-12 mb-0">
                  Track performance with comprehensive analytics and usage statistics.
                  </p>
                </div>
              </div>
            </Col>

            <Col md={4} className='position-relative mt-5'>
            <div className="borderThick"></div>
              <div className="h-100 border-0 pb-4 card-one border-thick position-relative bg-white">
                
                <div className="p-4">
                  <div className="feature-icon mb-4"  style={{height: '30px'}}>
                    <Image src={UserManagementIcon} width={30}/>
                  </div>

                  <h4 className="fw-700 fs-18">User Management</h4>
                  <p className="fw-400 fs-12 mb-0">
                  Manage accounts, users, and permissions with different access levels.
                  </p>
                </div>
              </div>
            </Col>


            <Col md={4} className='position-relative mt-5'>
            <div className="borderThick"></div>
              <div className="h-100 border-0 pb-4 card-one border-thick position-relative bg-white">
                
                <div className="p-4">
                  <div className="feature-icon mb-4" style={{height: '30px'}}>
                    <Image src={CreditManagementIcon} width={30}/>
                  </div>

                  <h4 className="fw-700 fs-18">Credit Management</h4>
                  <p className="fw-400 fs-12 mb-0">
                  Monitor and manage credit usage across your organization.
                  </p>
                </div>
              </div>
            </Col>

            <Col md={4} className='position-relative mt-5'>
            <div className="borderThick"></div>
              <div className="h-100 border-0 pb-4 card-one border-thick position-relative bg-white">
                
                <div className="p-4">
                  <div className="feature-icon mb-4" style={{height: '30px'}}>
                    <Image src={APIIntegrationIcon} width={30}/>
                  </div>

                  <h4 className="fw-700 fs-18">API Integration</h4>
                  <p className="fw-400 fs-12 mb-0">
                  Integrate URL shortening into your applications with our robust API.
                  </p>
                </div>
              </div>
            </Col>


          </Row>
        </Container>
      </section>



      <section className="bg-F5F5F5 page-section">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-700 ls-0 fs-34 mb-3">How It Works</h2>
            <p className="lead sub-heading">Get started in three simple steps: sign up, enter your long URL, and instantly create a shortened link to share anywhere.</p>
          </div>
          
          <Row className="g-4 z-0 position-relative justify-content-center">
            <Image className='wave-line d-lg-block d-none' src={waveLine}/>
            <Col md={4}>
              <div className="text-center pe-5 ps-5">
                <Image src={stepOne} height={150} className='stepsIcon mb-4'/>
                <h4 className="fw-600 mb-3">Sign Up</h4>
                <p className="">Create an account and get access to all features</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="text-center pe-5 ps-5">
                <Image src={stepTwo} height={150} className='stepsIcon mb-4'/>
                <h4 className="fw-600 mb-3">Setup Information</h4>
                <p className="">Set up your domains, sender IDs, and user permissions</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="text-center pe-5 ps-5">
                <Image src={stepThree} height={150} className='stepsIcon mb-4'/>
                <h4 className="fw-600 mb-3">Start Shortening</h4>
                <p className="">Generate short URLs individually or in bulk</p>
              </div>
            </Col>
          </Row>
          
        </Container>
      </section>

      {/* <section id="pricing" className="page-section">
        <Container>
          <div className="text-center mb-4">
            <h2 className="fw-700 ls-0 fs-34 mb-2">Choose Plan That’s Right For You</h2>
            <p className="lead sub-heading">Choose plan that works best for you, feel free to contact us</p>
          </div>
          
    <Tabs defaultActiveKey="monthly" id="pricing-tabs" className="mb-4 justify-content-center pricing-tab">
      <Tab eventKey="monthly" title="Bill Monthly">
        
        <Row className='justify-content-center mt-5'>
          <Col lg={10}>
          <Row className="g-4 justify-content-center">
            <Col lg={4} md={6}>
              <Card className="pricing-card">
                <Card.Header className="bg-white text-center border-0 pt-5 pb-0 ps-5 pe-5">
                  <h4 className="fw-600">Free</h4>
                  
                    <p className="fw-500 fs-14 mb-4" style={{color:'#A6A6A6'}}>Have a go and test your  superpowers</p>
                  <div className="price-value"><h2 class="fw-600 mb-0 fs-36 position-relative m-auto" style={{width:'fit-content'}}><span className='dollarSign'>$</span>0</h2>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ul className="list-unstyled mb-0 price-feature-list">
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      Basic URL shortening
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      500 URLs per month
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      Basic analytics
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      Custom domains
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      User management
                    </li>
                    <Button variant="success-outline-btn mt-2" className="w-100">Sign Up Free</Button>
                  </ul>

                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6}>
              <Card className="h-100 pricing-card bg-00C76F">
                <Card.Header className="text-center bg-00C76F border-0 pt-5 pb-0 ps-5 pe-5">
                  <h4 className="fw-600 text-white">Business</h4>
                  
                    <p className="fw-500 fs-14 mb-4 text-white" style={{color:'#A6A6A6'}}>Experiment the power of infinite possibilities</p>
                  <div className="price-value"><h2 class="fw-600 text-white mb-0 fs-36 position-relative m-auto" style={{width:'fit-content'}}><span className='dollarSign text-white'>$</span>49</h2>
                  <span className='spanText d-block mt-1'>Save $50 a year</span>
                  </div>
                </Card.Header>
                <Card.Body className='bg-00C76F'>
                  <ul className="list-unstyled mb-0 price-feature-list">
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Advanced URL shortening
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    10,000 URLs per month
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Full analytics dashboard
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    1 custom domain
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Up to 5 users
                    </li>
                    <Button variant="success-btn mt-2" className="w-100">Start Trial</Button>
                  </ul>

                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6}>
              <Card className="pricing-card">
                <Card.Header className="bg-white text-center border-0 pt-5 pb-0 ps-5 pe-5">
                  <h4 className="fw-600">Enterprise</h4>
                  
                    <p className="fw-500 fs-14 mb-4" style={{color:'#A6A6A6'}}>Unveil new superpowers and join the Design Leaque</p>
                  <div className="price-value"><h2 class="fw-600 mb-0 fs-36 position-relative m-auto" style={{width:'fit-content'}}><span className='dollarSign'>$</span>16</h2>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ul className="list-unstyled mb-0 price-feature-list">
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    All Business features
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Account success Manager
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Single Sign-On (SSO)
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Co-conception pogram
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Collaboration-Soon
                    </li>
                    <Button variant="success-outline-btn" className="w-100">Go to Enterprise</Button>
                  </ul>

                </Card.Body>
              </Card>
            </Col>
          </Row>
          </Col>
        </Row>

      </Tab>
      <Tab eventKey="yearly" title="Bill Yearly">
        

      <Row className='justify-content-center mt-5'>
          <Col lg={10}>
          <Row className="g-4 justify-content-center">
            <Col lg={4} md={6}>
              <Card className="pricing-card">
                <Card.Header className="bg-white text-center border-0 pt-5 pb-0 ps-5 pe-5">
                  <h4 className="fw-600">Free</h4>
                  
                    <p className="fw-500 fs-14 mb-4" style={{color:'#A6A6A6'}}>Have a go and test your  superpowers</p>
                  <div className="price-value"><h2 class="fw-600 mb-0 fs-36 position-relative m-auto" style={{width:'fit-content'}}><span className='dollarSign'>$</span>0</h2>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ul className="list-unstyled mb-0 price-feature-list">
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      Basic URL shortening
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      500 URLs per month
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      Basic analytics
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      Custom domains
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                      User management
                    </li>
                    <Button variant="success-outline-btn mt-2" className="w-100">Sign Up Free</Button>
                  </ul>

                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6}>
              <Card className="h-100 pricing-card bg-00C76F">
                <Card.Header className="text-center  bg-00C76F border-0 pt-5 pb-0 ps-5 pe-5">
                  <h4 className="fw-600 text-white">Business</h4>
                  
                    <p className="fw-500 fs-14 mb-4 text-white" style={{color:'#A6A6A6'}}>Experiment the power of infinite possibilities</p>
                  <div className="price-value"><h2 class="fw-600 text-white mb-0 fs-36 position-relative m-auto" style={{width:'fit-content'}}><span className='dollarSign text-white'>$</span>499</h2>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ul className="list-unstyled mb-0 price-feature-list">
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Advanced URL shortening
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    10,000 URLs per month
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Full analytics dashboard
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    1 custom domain
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Up to 5 users
                    </li>
                    <Button variant="success-btn mt-2" className="w-100">Start Trial</Button>
                  </ul>

                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6}>
              <Card className="pricing-card">
                <Card.Header className="bg-white text-center border-0 pt-5 pb-0 ps-5 pe-5">
                  <h4 className="fw-600">Enterprise</h4>
                  
                    <p className="fw-500 fs-14 mb-4" style={{color:'#A6A6A6'}}>Unveil new superpowers and join the Design Leaque</p>
                  <div className="price-value"><h2 class="fw-600 mb-0 fs-36 position-relative m-auto" style={{width:'fit-content'}}><span className='dollarSign'>$</span>149</h2>
                  
                  </div>
                </Card.Header>
                <Card.Body>
                  <ul className="list-unstyled mb-0 price-feature-list">
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    All Business features
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Account success Manager
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Single Sign-On (SSO)
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Co-conception pogram
                    </li>
                    <li className="d-flex align-items-center mb-3">
                    <div className='checkIcon'><FontAwesomeIcon icon={faCheck} /></div>
                    Collaboration-Soon
                    </li>
                    <Button variant="success-outline-btn" className="w-100">Go to Enterprise</Button>
                  </ul>

                </Card.Body>
              </Card>
            </Col>
          </Row>
          </Col>
        </Row>
      </Tab>
    </Tabs>


        </Container>
      </section> */}

      <section id="documentation" className="bg-F5F5F5 page-section">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-700 ls-0 fs-34 mb-3">Resources</h2>
            <p className="lead sub-heading">Everything you need to get started</p>
          </div>
          
          <Row className="g-4">
            <Col md={4}>
              <div className="h-100 border-0 shadow-0">
                <div className="">
                  <div className="bg-white p-3" style={{boxShadow: '0px 4px 9px 0px #0000000D', width:"55px", marginBottom:'35px'}}>
                    <Image src={zigzagIcon} className="w-100" />
                  </div>
                  <h4 className="fw-700  mb-3">User Manual</h4>
                  <p>
                    Comprehensive guide on how to use all features of our application.
                  </p>
                  <Button variant="read-success-btn" onClick={() => setShowGuideModal(true)}>Read Guide</Button>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="h-100 border-0 shadow-0">
                <div className="">
                  <div className="bg-white p-3" style={{boxShadow: '0px 4px 9px 0px #0000000D', width:"55px", marginBottom:'35px'}}>
                    <Image src={apiDocIcon} className="w-100" />
                  </div>
                  <h4 className="fw-700  mb-3">API Documentation</h4>
                  <p>
                  Detailed API reference to integrate URL shortening into your applications.                  </p>
                  <Button variant="read-success-btn" onClick={() => setShowApiModal(true)}>View Documents</Button>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="h-100 border-0 shadow-0">
                <div className="">
                  <div className="bg-white p-3" style={{boxShadow: '0px 4px 9px 0px #0000000D', width:"55px", marginBottom:'35px'}}>
                    <Image src={supportIcon} className="w-100" />
                  </div>
                  <h4 className="fw-700  mb-3">Support</h4>
                  <p>Get help from our support team for any questions or issues.</p>
                  <Button
                    variant="read-success-btn"
                    onClick={() => {
                      const el = document.getElementById('support');
                      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                  >
                    Contact Support
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Modal show={showGuideModal} onHide={() => setShowGuideModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fs-16">User Manual</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 className="fw-600">Overview</h6>
          <p>This guide explains Accounts, Domains, URL Shortening, SFTP Connectors, and Reports.</p>
          <h6 className="fw-600">Accounts & Domains</h6>
          <ul>
            <li>Use Account Details to manage domains and default domain.</li>
            <li>SUPERADMIN can run Verify Now to check reachability; feedback shows in toasts.</li>
          </ul>
          <h6 className="fw-600">URL Shortening</h6>
          <ul>
            <li>Create single or bulk shortened URLs.</li>
            <li>Bulk: download template, upload CSV, or import from SFTP via configuration and remote path.</li>
          </ul>
          <h6 className="fw-600">SFTP Connectors</h6>
          <ul>
            <li>Save connection: host, port, username, password, remote directory.</li>
            <li>Test connection to validate credentials.</li>
            <li>View existing configurations in the table with type and status.</li>
          </ul>
          <h6 className="fw-600">Reports → Export to SFTP</h6>
          <ul>
            <li>Select report type: Click Data, URL Shortening, Credit Record, Credit Consumption.</li>
            <li>Apply filters; credit reports require transaction and credit type.</li>
            <li>Choose an export SFTP config and save schedule.</li>
          </ul>
          <h6 className="fw-600">Troubleshooting</h6>
          <ul>
            <li>Enter password before testing SFTP.</li>
            <li>Ensure correct configType (import/export) for the context.</li>
            <li>Toasts display detailed messages from the server for quick fixes.</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowGuideModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showApiModal} onHide={() => setShowApiModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fs-16">API Documentation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 className="fw-600">Base URLs</h6>
          <ul>
            <li>User services: <code>USER_URL</code></li>
            <li>URL shortening: <code>URL_SHORTEN</code></li>
          </ul>
          <h6 className="fw-600">Endpoints</h6>
          <ul>
            <li>Bulk upload template: <code>GET /api/bulk-upload/template</code></li>
            <li>Bulk upload file: <code>POST /api/bulk-upload/upload</code></li>
            <li>Bulk import from SFTP: <code>POST /api/bulk-upload/import-sftp</code></li>
            <li>List SFTP configs: <code>{'GET /api/account-configs/{accountId}/sftp-config'}</code></li>
            <li>List SFTP by type: <code>{'GET /api/account-configs/{accountId}/sftp-config/by-type?configType=import|export'}</code></li>
            <li>Create SFTP config: <code>{'POST /api/account-configs/{accountId}/sftp-config'}</code></li>
            <li>Update SFTP config: <code>{'PUT /api/account-configs/{accountId}/sftp-config/{configId}'}</code></li>
            <li>Test SFTP connection: <code>{'POST /api/account-configs/{accountId}/sftp-config/{configId}/test'}</code></li>
            <li>Create export schedule: <code>{'POST /api/account-configs/{accountId}/sftp-config/schedule'}</code></li>
            <li>Check domain: <code>POST /api/account-configs/check-domain</code></li>
          </ul>
          <h6 className="fw-600">Auth</h6>
          <p>All requests use the access token in `Authorization: Bearer &lt;token&gt;`.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowApiModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <section id="support" className="page-section bg-161C28">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
             <div className='mb-5'>
              <h2 className="fw-600 text-white fs-40 mb-4">Need Help?</h2>
              <p className="fw-500 fs-15 text-A6A6A6" style={{color:"#A6A6A6"}}>Our team is available to answer any questions you may have about our URL shortening service.</p>
              </div>

              <div className="mb-4" style={{marginTop:'80px'}}>
                <h5 className="fw-500 text-white fs-16 mb-1">Email</h5>
                <p><a href="mailto:support@shorturl.com" style={{color:"#A6A6A6"}} className="fw-500 fs-14 text-decoration-underline">support@shorturl.com</a></p>
              </div>
              
              <div className='mt-5'>
                <h5 className="fw-500 text-white fs-16 mb-1">Office Hours</h5>
                <p style={{color:"#A6A6A6"}} className="fw-500 fs-14 mb-0">Monday - Friday: 9:00 AM - 6:00 PM EST</p>
              </div>
            </Col>
            <Col lg={6}>
              <Card className="border-0 p-5 pt-3 pb-4 form-dark-footer">
                <Card.Body className="p-4">
                  <div className='text-center'>
                  <Image src={contactIocn} className='mb-2' width={55}/>
                  <h4 className="fw-bold mb-4 text-white">Get Started</h4>
                  </div>
                  <form>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label label-white" style={{color:'#fff !important'}}>Email</label>
                      <input type="email" className="form-control" id="email" placeholder="Enyer your email" />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="message" className="form-label label-white">Message</label>
                      <textarea className="form-control" id="message" rows="3" placeholder="Write a msg here.."></textarea>
                    </div>
                    <Button variant="primary" type="submit" className="w-100" style={{paddingTop:'13px', paddingBottom:'13px'}}>Request Demo</Button>
                  </form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <footer className="text-white py-5" style={{backgroundColor:'#161C28'}}>
        <Container>
          <Row className="g-4">
            <Col lg={6} md={6}>
              <h5 className="mb-4 fw-600 fs-32" style={{color:'#00C76F'}}><Image src={Logo} height="40"/></h5>
              <p className="fw-500 fs-14 mb-4" style={{color:'#A6A6A6'}}>Get started now try our product</p>
              <Form className=''>
                <div className='subscriptionForm'>
                <Form.Control type="email" placeholder="Enter your email here" />
                <button className='arrowSubmitBtn' type="submit">
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
                </div>
              </Form>
            </Col>
            <Col lg={6}>
            <Row>
            <Col lg={4} md={6}>
              <h5 className="mb-4 fw-500 fs-14">Support</h5>
              <ul className="list-unstyled footer-list">
                <li className="mb-2"><a href="#" className="">Help centre</a></li>
                <li className="mb-2"><a href="#" className="">Account information</a></li>
                <li className="mb-2"><a href="#" className="">About</a></li>
                <li className="mb-2"><a href="#" className="">Contact us</a></li>
              </ul>
            </Col>
            <Col lg={4} md={6}>
              <h5 className="mb-4 fw-500 fs-14">Help and Solution</h5>
              <ul className="list-unstyled footer-list">
                <li className="mb-2"><a href="#" className="">Talk to support</a></li>
                <li className="mb-2"><a href="#" className="">Support docs</a></li>
                <li className="mb-2"><a href="#" className="">System status</a></li>
              </ul>
            </Col>
            <Col lg={4} md={6}>
              <h5 className="mb-4 fw-500 fs-14">Product</h5>
              <ul className="list-unstyled footer-list">
                <li className="mb-2"><a href="#" className="">Talk to support</a></li>
                <li className="mb-2"><a href="#" className="">Support docs</a></li>
                <li className="mb-2"><a href="#" className="">System status</a></li>
              </ul>
            </Col>
            </Row>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5">
            <p className="mb-3 mb-md-0 fs-14 text-white">© 2025 Lynksense. Copyright and rights reserved</p>
            <div className='other-links'>
              <a href="#" className="text-white text-decoration-none me-3 fs-14">Terms and Condtions</a>
              <a href="#" className="text-white text-decoration-none me-3 fs-14">Privacy Policy</a>
            </div>
          </div>
          </Col>
          </Row>
        </Container>
      </footer>
      </div>
    </>
  );
};

export default LandingPage;